// Date 2021-10-12 15:44:47

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";
import emWorkflowListView from "@/components/em/EmWorkflow/ListView";
import emWorkflowTaskView from "@/components/em/EmWorkflow/TaskView";
import emLevelTreeListView from "@/components/em/EmLevelTree/ListView";

            import mintalMesQualityCompoundList from "@/views/mintalMes/quality/MintalMesQualityCompoundList.vue";
            import mintalMesQualityCompoundEdit from "@/views/mintalMes/quality/MintalMesQualityCompoundEdit.vue";
            import mintalMesQualityProductionProjectEdit from "@/views/mintalMes/quality/MintalMesQualityProductionProjectEdit.vue";
            import mintalMesQualityProductionProjectList from "@/views/mintalMes/quality/MintalMesQualityProductionProjectList.vue";
            import mintalMesQualityProductionSampleList from "@/views/mintalMes/quality/MintalMesQualityProductionSampleList.vue";
            import mintalMesQualityProductionSampleEdit from "@/views/mintalMes/quality/MintalMesQualityProductionSampleEdit.vue";
            import mintalMesQualityProductionSampleItemEdit from "@/views/mintalMes/quality/MintalMesQualityProductionSampleItemEdit.vue";
            import mintalMesQualityProductionSampleItemList from "@/views/mintalMes/quality/MintalMesQualityProductionSampleItemList.vue";
            import mintalMesQualityProjectEdit from "@/views/mintalMes/quality/MintalMesQualityProjectEdit.vue";
            import mintalMesQualityProjectList from "@/views/mintalMes/quality/MintalMesQualityProjectList.vue";
            import mintalMesQualityProjectItemList from "@/views/mintalMes/quality/MintalMesQualityProjectItemList.vue";
            import mintalMesQualityProjectItemEdit from "@/views/mintalMes/quality/MintalMesQualityProjectItemEdit.vue";
            import mintalMesQualitySelfInspectEdit from "@/views/mintalMes/quality/MintalMesQualitySelfInspectEdit.vue";
            import mintalMesQualitySelfInspectList from "@/views/mintalMes/quality/MintalMesQualitySelfInspectList.vue";
            import mintalMesQualitySelfInspectGrindEdit from "@/views/mintalMes/quality/MintalMesQualitySelfInspectGrindEdit.vue";
            import mintalMesQualitySelfInspectGrindList from "@/views/mintalMes/quality/MintalMesQualitySelfInspectGrindList.vue";
            import mintalMesQualitySelfInspectPelletizeList from "@/views/mintalMes/quality/MintalMesQualitySelfInspectPelletizeList.vue";
            import mintalMesQualitySelfInspectPelletizeEdit from "@/views/mintalMes/quality/MintalMesQualitySelfInspectPelletizeEdit.vue";
            import mintalMesQualitySelfInspectRoastList from "@/views/mintalMes/quality/MintalMesQualitySelfInspectRoastList.vue";
            import mintalMesQualitySelfInspectRoastEdit from "@/views/mintalMes/quality/MintalMesQualitySelfInspectRoastEdit.vue";
const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
//自定义页面注册
            {
            path: "/mintalMes/quality/mintalMesQualityCompoundList",
            name: "mintalMesQualityCompoundList",
            component: mintalMesQualityCompoundList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualityCompoundEdit",
            name: "mintalMesQualityCompoundEdit",
            component: mintalMesQualityCompoundEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualityProductionProjectEdit",
            name: "mintalMesQualityProductionProjectEdit",
            component: mintalMesQualityProductionProjectEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualityProductionProjectList",
            name: "mintalMesQualityProductionProjectList",
            component: mintalMesQualityProductionProjectList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualityProductionProjectList/production",
            name: "mintalMesQualityProductionProjectListProduction",
            component: mintalMesQualityProductionProjectList,
            props: (route) => ({ prop_inline: route.query.inline, customVuexName: 'production' }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualityProductionProjectList/mintalMesQualityProductionProjectInventory",
            name: "mintalMesQualityProductionProjectInventory",
            component: mintalMesQualityProductionProjectList,
            props: (route) => ({ prop_inline: route.query.inline, customVuexName: 'mintalMesQualityProductionProjectInventory' }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualityProductionSampleInspectList",
            name: "mintalMesQualityProductionSampleInspectList",
            component: mintalMesQualityProductionSampleList,
            props: (route) => ({ prop_inline: route.query.inline, customVuexNameInit: 'inspect' }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualityProductionSampleList",
            name: "mintalMesQualityProductionSampleList",
            component: mintalMesQualityProductionSampleList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualityProductionSampleEdit",
            name: "mintalMesQualityProductionSampleEdit",
            component: mintalMesQualityProductionSampleEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualityProductionSampleItemEdit",
            name: "mintalMesQualityProductionSampleItemEdit",
            component: mintalMesQualityProductionSampleItemEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualityProductionSampleItemList",
            name: "mintalMesQualityProductionSampleItemList",
            component: mintalMesQualityProductionSampleItemList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualityProjectEdit",
            name: "mintalMesQualityProjectEdit",
            component: mintalMesQualityProjectEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualityProjectList",
            name: "mintalMesQualityProjectList",
            component: mintalMesQualityProjectList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualityProjectItemList",
            name: "mintalMesQualityProjectItemList",
            component: mintalMesQualityProjectItemList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualityProjectItemEdit",
            name: "mintalMesQualityProjectItemEdit",
            component: mintalMesQualityProjectItemEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualitySelfInspectEdit",
            name: "mintalMesQualitySelfInspectEdit",
            component: mintalMesQualitySelfInspectEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualitySelfInspectList",
            name: "mintalMesQualitySelfInspectList",
            component: mintalMesQualitySelfInspectList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualitySelfInspectGrindEdit",
            name: "mintalMesQualitySelfInspectGrindEdit",
            component: mintalMesQualitySelfInspectGrindEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualitySelfInspectGrindList",
            name: "mintalMesQualitySelfInspectGrindList",
            component: mintalMesQualitySelfInspectGrindList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualitySelfInspectPelletizeList",
            name: "mintalMesQualitySelfInspectPelletizeList",
            component: mintalMesQualitySelfInspectPelletizeList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualitySelfInspectPelletizeEdit",
            name: "mintalMesQualitySelfInspectPelletizeEdit",
            component: mintalMesQualitySelfInspectPelletizeEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualitySelfInspectRoastList",
            name: "mintalMesQualitySelfInspectRoastList",
            component: mintalMesQualitySelfInspectRoastList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/quality/mintalMesQualitySelfInspectRoastEdit",
            name: "mintalMesQualitySelfInspectRoastEdit",
            component: mintalMesQualitySelfInspectRoastEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            }
]